import { createContext, useState, useMemo } from "react";
import PropTypes from "prop-types";

const context = {
    settings: {},
    accounts: null,
    updateSettings: () => {},
    updateAccounts: () => {},
    clearAccountData: () => {},
    loadingSettings: false,
    setLoadingSettings: () => {}
}

export const UserAccountContext = createContext(context);

const UserAccountContextProvider = ({ children }) => {
    const [settings, setSettings] = useState({});
    const [accounts, setAccounts] = useState(null);
    const [loadingSettings, setLoadingSettings] = useState(false);

    const updateSettings = (newSettings) => {
        setSettings(prevSettings => ({
            ...prevSettings,
            ...newSettings
        }));
    }

    const clearAccountData = () => {
        setSettings({});
        setAccounts(null);
    }

    /**
     * Updates user accounts in context
     * @param {object[]|null} newAccounts
     */
    const updateAccounts = (newAccounts) => {
        setAccounts(newAccounts);
    }

    const providerValue = useMemo(() => (
        { settings, updateSettings, clearAccountData, accounts, updateAccounts, loadingSettings, setLoadingSettings }
    ), [settings, updateSettings, clearAccountData, accounts, updateAccounts, loadingSettings, setLoadingSettings]);

    return (
        <UserAccountContext.Provider value={providerValue}>
            {children}
        </UserAccountContext.Provider>
    )
}

UserAccountContextProvider.propTypes = {
    children: PropTypes.node.isRequired
};

export default UserAccountContextProvider;
